var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-page info-group" }, [
    _c("div", { staticClass: "application-form-height" }, [
      _c(
        "div",
        [
          _vm.physicalInfo
            ? _c(
                "van-form",
                { ref: "form" },
                [
                  _c(
                    "van-cell-group",
                    [
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userInfo.userName"
                          ),
                          label: "姓名",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        staticClass: "hide-value",
                        attrs: {
                          rules: [
                            {
                              required: true,
                              message: "请选择",
                              trigger: "onChange"
                            }
                          ],
                          label: "性别",
                          required: "",
                          "input-align": "right",
                          center: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button",
                              fn: function() {
                                return [
                                  _c(
                                    "van-radio-group",
                                    {
                                      attrs: {
                                        direction: "horizontal",
                                        disabled: !!_vm.physicalInfo.userInfo
                                          .confirm
                                      },
                                      model: {
                                        value: _vm.formData.sex,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formData, "sex", $$v)
                                        },
                                        expression: "formData.sex"
                                      }
                                    },
                                    [
                                      _c(
                                        "van-radio",
                                        { attrs: { name: "男" } },
                                        [_vm._v(" 男 ")]
                                      ),
                                      _c(
                                        "van-radio",
                                        { attrs: { name: "女" } },
                                        [_vm._v(" 女 ")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          993577451
                        ),
                        model: {
                          value: _vm.formData.sex,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "sex", $$v)
                          },
                          expression: "formData.sex"
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userInfo.age"
                          ),
                          label: "年龄",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          label: "手机号码",
                          required: "",
                          type: "tel",
                          "input-align": "right",
                          center: "",
                          disabled: !!_vm.physicalInfo.userInfo.confirm
                        },
                        model: {
                          value: _vm.formData.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "mobile", $$v)
                          },
                          expression: "formData.mobile"
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          label: "身份证号",
                          required: "",
                          "input-align": "right",
                          center: "",
                          disabled: !!_vm.physicalInfo.userInfo.confirm
                        },
                        model: {
                          value: _vm.formData.id_card,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "id_card", $$v)
                          },
                          expression: "formData.id_card"
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userType.userTypeName"
                          ),
                          label: "人员类型",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        staticClass: "hide-value",
                        attrs: {
                          rules: [
                            {
                              required: true,
                              message: "请选择",
                              trigger: "onChange"
                            }
                          ],
                          label: "婚姻状况",
                          required: "",
                          "input-align": "right",
                          center: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button",
                              fn: function() {
                                return [
                                  _c(
                                    "van-radio-group",
                                    {
                                      attrs: {
                                        direction: "horizontal",
                                        disabled: !!_vm.physicalInfo.userInfo
                                          .confirm
                                      },
                                      model: {
                                        value: _vm.formData.marital_status,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "marital_status",
                                            $$v
                                          )
                                        },
                                        expression: "formData.marital_status"
                                      }
                                    },
                                    [
                                      _c(
                                        "van-radio",
                                        { attrs: { name: "1" } },
                                        [_vm._v(" 已婚 ")]
                                      ),
                                      _c(
                                        "van-radio",
                                        { attrs: { name: "0" } },
                                        [_vm._v(" 未婚 ")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          411713017
                        ),
                        model: {
                          value: _vm.formData.marital_status,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "marital_status", $$v)
                          },
                          expression: "formData.marital_status"
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "dept.deptName"
                          ),
                          label: "体检对口管理业务部门",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          label: "对口管理业务部门电话",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function() {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tel",
                                      attrs: {
                                        href:
                                          "tel:" +
                                          _vm.$utils.getValueByProp(
                                            _vm.physicalInfo,
                                            "dept.phone"
                                          )
                                      }
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: { name: "tel" }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("getValueByProp")(
                                              _vm.physicalInfo,
                                              "dept.phone"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3273119010
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "buttons-panel" },
                    [
                      !_vm.physicalInfo.userInfo.confirm
                        ? _c(
                            "van-button",
                            {
                              staticClass: "submit mb-2",
                              attrs: { type: "info", size: "large" },
                              on: { click: _vm.formSubmit }
                            },
                            [_vm._v(" 确认&修改 ")]
                          )
                        : _vm._e(),
                      _c(
                        "van-button",
                        {
                          attrs: { type: "info", size: "large", plain: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.go(-1)
                            }
                          }
                        },
                        [_vm._v(" 返回 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }